import { OAuthTokensTable } from '@/components/iam/OAuthTokensTable';

export const OAuthClientTokensTab = ({ clientId }: { clientId: string }) => (
  <OAuthTokensTable
    filter={{ field: 'client_id', value: clientId }}
    titleKey="iam.oauth_clients.tabs.tokens"
  />
);
